import { Island } from '../../../islands/island.class';
import { ReferenceMap } from '../../../shared.types';

type IsIslandVentingRequiredParams = {
	island: Island;
	refMap: ReferenceMap;
	excludeItemRefs?: Array<string>;
};

export const isIslandVentingRequired = ({ island }: IsIslandVentingRequiredParams): boolean => {
	if (!island?.panels?.children) return false;

	let ventsRequired = false;

	island.panels.children.forEach((panel) => {
		panel.panelItemGroups.children.forEach((group) => {
			// eslint-disable-next-line consistent-return
			group.items.children.forEach((panelItem) => {
				const fuelSourced = panelItem.item.fuel;
				if (fuelSourced) {
					ventsRequired = true;
					return ventsRequired;
				}
			})
		})
	})
	return ventsRequired;
};
